export const AUTHENTICATION_PLATFORM_FEATURES = {
  LOGIN_SSO_ENTRA_ID: 'login.sso.entraId',
  LOGIN_SSO_GOOGLE: 'login.sso.google',
};

export const AUTHENTICATION_PLATFORM_FEATURE_CONFIG = {
  BCH: {
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_ENTRA_ID]: true,
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_GOOGLE]: false,
  },

  ITAU: {
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_ENTRA_ID]: true,
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_GOOGLE]: false,
  },

  SANTANDER: {
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_ENTRA_ID]: false,
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_GOOGLE]: false, // Will be enabled in the future
  },

  FINGO: {
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_ENTRA_ID]: false,
    [AUTHENTICATION_PLATFORM_FEATURES.LOGIN_SSO_GOOGLE]: false, // Will be enabled in the future
  },
};
